import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

type Props = {
  hide: () => void;
  isShow: boolean;
};

export const WhatIsSetAccountModal = ({
  hide,
  isShow,
}: Props): React.ReactElement => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-lg leading-6">
            目標達成がひと目で分かる！
            <br />
            各口座の資産を自動で反映します
          </div>
          <div className="flex flex-row items-center mt-4">
            <img
              src="/static/images/advisor/circle-check.svg"
              alt=""
              className=""
              style={{ width: '16px', height: '16px' }}
            />
            <div className="ml-2 text-base">各口座の資産額を自動で集計</div>
          </div>
          <div className="flex flex-row items-center mt-1 mb-4">
            <img
              src="/static/images/advisor/circle-check.svg"
              alt=""
              className=""
              style={{ width: '16px', height: '16px' }}
            />
            <div className="ml-2 text-base">目標達成までを見える化</div>
          </div>
          <div className="flex flex-row justify-center">
            <img
              src="/static/images/advisor/account-settings.svg"
              alt="口座の設定"
              style={{ width: '345px', height: '400px' }}
            />
          </div>
          <button
            className="mt-6 p-2 font-bold text-bluegray-500 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
